export default {
  path: '/administrative',
  component: () => import('@/views/administrative/Index'),
  redirect: { name: 'administrative-suppliers-list' },
  children: [
    {
      path: 'suppliers',
      component: () => import('@/views/administrative/suppliers/Index'),
      children: [
        {
          path: '',
          name: 'administrative-suppliers-list',
          component: () => import('@/views/administrative/suppliers/List'),
          meta: {
            title: 'List of suppliers',
            roles: ['general_manager', 'accountant_supervisor', 'accountant_manager']
          }
        },
        {
          path: ':id',
          component: () => import('@/views/administrative/suppliers/detail/Layout'),
          children: [
            {
              path: '',
              name: 'administrative-suppliers-detail-purchases',
              component: () => import('@/views/administrative/suppliers/detail/Purchases'),
              meta: {
                title: 'Supplier detail',
                roles: ['general_manager', 'accountant_supervisor', 'accountant_manager']
              }
            },
            {
              path: 'payment-methods',
              name: 'administrative-suppliers-detail-payment-methods',
              component: () => import('@/views/administrative/suppliers/detail/PaymentMethods'),
              meta: {
                title: 'Supplier detail',
                roles: ['general_manager', 'accountant_supervisor', 'accountant_manager']
              }
            },
            {
              path: 'contacts',
              name: 'administrative-suppliers-detail-contacts',
              component: () => import('@/views/administrative/suppliers/detail/Contacts'),
              meta: {
                title: 'Supplier detail',
                roles: ['general_manager', 'accountant_supervisor', 'accountant_manager']
              }
            },
          ],
        },
      ]
    },
    {
      path: 'properties',
      component: () => import('@/views/administrative/properties/Index'),
      children: [
        {
          path: '',
          name: 'administrative-properties-list',
          component: () => import('@/views/administrative/properties/List'),
          meta: {
            title: 'Properties',
            roles: ['general_manager', 'accountant_supervisor']
          }
        },
        {
          path: ':id',
          component: () => import('@/views/administrative/properties/detail/Layout'),
          children: [
            {
              path: '',
              name: 'administrative-properties-detail-lease-agreements',
              component: () => import('@/views/administrative/properties/detail/LeaseAgreements'),
              meta: {
                title: 'Properties',
                roles: ['general_manager', 'accountant_supervisor']
              }
            },
            {
              path: 'insurances',
              name: 'administrative-properties-detail-insurances',
              component: () => import('@/views/administrative/properties/detail/Insurances'),
              meta: {
                title: 'Properties',
                roles: ['general_manager', 'accountant_supervisor']
              }
            },
          ],
        },
      ]
    },
    {
      path: 'legal-entities',
      component: () => import('@/views/administrative/legal-entities/Index'),
      children: [
        {
          path: '',
          name: 'administrative-legal-entities-list',
          component: () => import('@/views/administrative/legal-entities/List'),
          meta: {
            title: 'Legal entities',
            roles: ['general_manager', 'accountant_supervisor']
          }
        },
        {
          path: ':id',
          component: () => import('@/views/administrative/legal-entities/detail/Layout'),
          children: [
            {
              path: '',
              name: 'administrative-legal-entities-detail-licenses',
              component: () => import('@/views/administrative/legal-entities/detail/Licenses'),
              meta: {
                title: 'Legal entities',
                roles: ['general_manager', 'accountant_supervisor']
              }
            },
            {
              path: 'insurances',
              name: 'administrative-legal-entities-detail-insurances',
              component: () => import('@/views/administrative/legal-entities/detail/Insurances'),
              meta: {
                title: 'Legal entities',
                roles: ['general_manager', 'accountant_supervisor']
              }
            },
          ],
        },
      ]
    },
    {
      path: 'domains',
      component: () => import('@/views/administrative/domains/Index'),
      children: [
        {
          path: '',
          name: 'domains',
          component: () => import('@/views/administrative/domains/List'),
          meta: {
            title: 'Domain tracker',
            roles: ['general_manager']
          }
        },
      ]
    },
    {
      path: 'land-purchase-contract',
      component: () => import('@/views/administrative/land-purchase-contract/Index'),
      children: [
        {
          path: '',
          name: 'land-purchase-contract-list',
          component: () => import('@/views/administrative/land-purchase-contract/List'),
          meta: {
            title: 'Land purchase contract',
            roles: ['general_manager', 'lawyer_manager']
          }
        },
        {
          path: 'map',
          name: 'land-purchase-contract-map',
          component: () => import('@/views/administrative/land-purchase-contract/Map'),
          meta: {
            title: 'Land purchase contract map',
            roles: ['general_manager', 'lawyer_manager']
          }
        },
        {
          path: ':id',
          name: 'land-purchase-contract-detail',
          component: () => import('@/views/administrative/land-purchase-contract/Detail'),
          meta: {
            title: 'Land purchase contract detail',
            roles: ['general_manager', 'lawyer_manager']
          }
        },
      ]
    },
  ]
}
